function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.147 3.228C7.794 18.443 6.296 44.021 21.7 56.675m0 0l-.081-6.964m.08 6.964l-6.2.898",
  stroke: "#FF6A00",
  strokeWidth: 2
});

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 61,
    viewBox: "0 0 42 61",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNjEiIHZpZXdCb3g9IjAgMCA0MiA2MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3LjE0NzEgMy4yMjgyMkM3Ljc5NDMzIDE4LjQ0MjYgNi4yOTU5NiA0NC4wMjEgMjEuNjk5OSA1Ni42NzUyTTIxLjY5OTkgNTYuNjc1MkwyMS42MTkgNDkuNzExNE0yMS42OTk5IDU2LjY3NTJMMTUuNDk5NCA1Ny41NzI4IiBzdHJva2U9IiNGRjZBMDAiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgArrow as ReactComponent };